import { render, staticRenderFns } from "./ViewCard.vue?vue&type=template&id=4031e271&scoped=true&"
import script from "./ViewCard.vue?vue&type=script&lang=js&"
export * from "./ViewCard.vue?vue&type=script&lang=js&"
import style0 from "./ViewCard.vue?vue&type=style&index=0&id=4031e271&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4031e271",
  null
  
)

component.options.__file = "ViewCard.vue"
export default component.exports